import React, {useEffect, useState} from 'react';
import {
    Box,
    Card,
    CardContent,
    FormControl,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    List,
    ListItem,
    Typography
} from "@deere/fuel-react";
import {CURRENT_AE_SUPPLIER_TITLE, SUPPLIER_QUESTION} from "../shared/Constants";
import {Dropdown} from "@deere/ux.uxframe-react";
import SearchIcon from "@material-ui/icons/Search";
import {toCapitalizeSplitStr} from "../shared/utils";
import {useAuthConfig} from "../shared/helper";
import {useOktaAuth} from "@okta/okta-react";
import {CampaignPeriod} from "./CampaignPeriod";
import {Loading} from "../shared/Loading";
import {ModalDialog} from "../shared/ModalDialog";
import {NoData} from "../shared/NoData";
import PropTypes from "prop-types"

export const CampaignSuppliers = ({
                                      control,
                                      errors,
                                      setValue,
                                      currentData,
                                      onSelectStep,
                                      onPeriodChange,
                                      onFiscalYearChange,
                                      onSupplierChange
                                  }) => {
    let authAxios = useAuthConfig();
    const {authState} = useOktaAuth();
    const [currentSuppliers, setCurrentSuppliers] = useState([]);
    const [selectedSupplierIndex, setSelectedSupplierIndex] = useState(-1);
    const [isLoading, setIsLoading] = useState(true);
    const [sortType, setSortType] = useState("Supplier Name A-Z");

    // State props for Filter results
    const [query, setQuery] = useState("");
    const [searchParam] = useState(["supplierName", "supplierNumber"]);

    const filterCurrentSuppliers = (items) => {
        return items.filter((item) => {
            return searchParam.some((param) => {
                return (
                    item[param]
                        .toString()
                        .toLowerCase()
                        .indexOf(query.toLowerCase()) > -1
                );
            });
        });
    }

    const handleFindSupplierChange = (value) => {
        setSelectedSupplierIndex(-1);
        handleSupplierChange(value);
    }

    const handlePeriodChange = (value) => {
        onPeriodChange(value)
    };

    const handleFiscalYearChange = (value) => {
        onFiscalYearChange(value)
    };

    const handleSupplierChange = (value) => {
        onSupplierChange(`${value.supplierName}${value.supplierNameLine2}`, value.supplierNumber)
    }

    const handleSupplierDelete = () => {
        setSelectedSupplierIndex(-1);
        onSupplierChange("", "")
    }

    const handleSetSortType = (value) => {
        setSortType(value)
        handleSort(value)
    }

    const handleSort = (sortType) => {
        let sortedList;
        if (sortType === "Supplier Name A-Z")
            sortedList = [...currentSuppliers].sort((a, b) => a.supplierName < b.supplierName ? -1 : (a.supplierName > b.supplierName ? 1 : 0));
        else if (sortType === "Supplier Name Z-A")
            sortedList = [...currentSuppliers].sort((a, b) => b.supplierName < a.supplierName ? -1 : (b.supplierName > a.supplierName ? 1 : 0));
        else if (sortType === "Supplier Number 0-9")
            sortedList = [...currentSuppliers].sort((a, b) => a.supplierNumber - b.supplierNumber);
        else if (sortType === "Supplier Number 9-0")
            sortedList = [...currentSuppliers].sort((a, b) => b.supplierNumber - a.supplierNumber);
        setCurrentSuppliers(sortedList)
    }

    const getCurrentSuppliers = async () => {
        try {
            return await authAxios.get(`/current-suppliers`);
        } catch (e) {
            console.error(e);
        }
    };
    useEffect(() => {
        onSelectStep(0);    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentData])

    useEffect(() => {
        getCurrentSuppliers().then(res => {
            const data = res.data;
            const sortedData = data && [...data].sort((a, b) => a.supplierName.localeCompare(b.supplierName));
            setCurrentSuppliers(sortedData);
            setIsLoading(false);
        });

        return () => {
            setCurrentSuppliers([]);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);

    return (
        <Grid container>
            <Grid item xs={4}>
                <Box mt={6} mb={2}>
                    <Card>
                        <CardContent>
                            <CampaignPeriod
                                control={control}
                                errors={errors}
                                supplierName={currentData.supplierName}
                                supplierNumber={currentData.supplierNumber}
                                currentData={currentData}
                                onDelete={handleSupplierDelete}
                                onPeriodValChange={handlePeriodChange}
                                onFiscalYearChange={handleFiscalYearChange}
                                setValue={setValue}/>
                        </CardContent>
                    </Card>
                </Box>
            </Grid>
            <Grid item xs={8}>
                <Box m={6}>
                    <Card>
                        <CardContent>
                            {isLoading && (
                                <Loading/>
                            )}
                            {!isLoading && (
                                <Box mt={2}>
                                    <Grid container alignItems="flex-start" spacing={2}>
                                        <Grid item xs={12}>
                                            <Typography size="sm" component="p" fontWeight="bold" display="block">
                                                {SUPPLIER_QUESTION}{" "}
                                                <span
                                                    aria-label="required field"
                                                    className="uxf-is-required"
                                                >
												    *
											    </span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <FormControl fullWidth>
                                                <Input fullWidth placeholder="Filter by supplier name or number"
                                                       id="search"
                                                       endAdornment={
                                                           <InputAdornment position="end">
                                                               <IconButton aria-label="search">
                                                                   <SearchIcon style={{color: " #367c2b"}}/>
                                                               </IconButton>
                                                           </InputAdornment>
                                                       }
                                                       onChange={(e) => setQuery(e.target.value)}/>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <Typography variant="label" style={{margin: "1rem"}} display="inline">
                                                Or
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <ModalDialog
                                                titleText={"Find Different Supplier"}
                                                saveButtonText={"Select"}
                                                page={"Supplier"}
                                                content={<></>}
                                                onSave={handleFindSupplierChange}
                                            />
                                        </Grid>
                                        <Grid item xs={7}>
                                            <Typography size="sm" fontWeight="bold" display="block"
                                                        style={{paddingLeft: 2, paddingTop: 2}}>
                                                {currentSuppliers.length !== 1 ? `${CURRENT_AE_SUPPLIER_TITLE}s` : CURRENT_AE_SUPPLIER_TITLE}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Box display="flex" justifyContent="flex-end">
                                                <Typography size="sm" fontWeight="bold" component="p"
                                                            style={{paddingRight: 10, paddingTop: 3}}>
                                                    Sort By
                                                </Typography>
                                                <Dropdown>
                                                    <Dropdown.Toggle variant="link" id="sort-dropdown"
                                                                     style={{padding: 0, fontSize: "0.875rem"}}>
                                                        {sortType}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item
                                                            onClick={() => handleSetSortType("Supplier Name A-Z")}>
                                                            Supplier Name A-Z
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            onClick={() => handleSetSortType("Supplier Name Z-A")}>
                                                            Supplier Name Z-A
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            onClick={() => handleSetSortType("Supplier Number 0-9")}>
                                                            Supplier Number 0-9
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            onClick={() => handleSetSortType("Supplier Number 9-0")}>
                                                            Supplier Number 9-0
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container alignItems="flex-start" spacing={4}>
                                        <Grid item xs={12}>
                                            <List disablePadding aria-label="supplier list"
                                                  style={{maxHeight: 300, overflow: "auto"}}>
                                                {(currentSuppliers.length > 0 && filterCurrentSuppliers(currentSuppliers).length > 0) ? filterCurrentSuppliers(currentSuppliers).map((supplier, index) => {
                                                    const supplierTitle = `${toCapitalizeSplitStr(supplier.supplierName)}${supplier.supplierNameLine2.toLowerCase()} - ${parseInt(supplier.supplierNumber)}`
                                                    const supplierAddress = `${toCapitalizeSplitStr(supplier.physicalAddress)}, ${toCapitalizeSplitStr(supplier.city)}, ${supplier.state}`
                                                    return (
                                                        <ListItem button
                                                                  divider={currentSuppliers.length !== index + 1}
                                                                  selected={index === selectedSupplierIndex}
                                                                  key={index}
                                                                  className="ListItem"
                                                                  style={{padding: ".5rem"}}
                                                                  onClick={() => {
                                                                      setSelectedSupplierIndex(index);
                                                                      handleSupplierChange(supplier);
                                                                  }}
                                                        >
                                                            <Grid container>
                                                                <Grid item xs={12}>
                                                                    <Typography color="primary" size="md"
                                                                                fontWeight="semibold"
                                                                    >
                                                                        {supplierTitle}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Typography color="secondary" size="sm">
                                                                        {supplierAddress}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </ListItem>
                                                    );
                                                }) : (
                                                    <NoData
                                                        noDataMessage={{textLine1: "No results found. Please try a new term or use Find Different Supplier"}}/>
                                                )}
                                            </List>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )}
                        </CardContent>
                    </Card>
                </Box>
            </Grid>
        </Grid>
    );
};

CampaignSuppliers.propTypes = {
    control: PropTypes.object,
    currentData: PropTypes.shape({
        supplierName: PropTypes.string,
        supplierNumber: PropTypes.string
    }),
    errors: PropTypes.object,
    onPeriodChange: PropTypes.func,
    onSelectStep: PropTypes.func,
    onSupplierChange: PropTypes.func,
    setValue: PropTypes.func
}
